
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import type { NextPage } from 'next';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import useTranslation from 'next-translate/useTranslation';
import data from '../content/resume';
import SEO from '@components/SEO';
import { Content } from '@components/Layout';
import { FC, useState } from 'react';
const Doc = styled.article `
  font-size: var(--font-text-s);
  font-family: var(--font-text);

  p {
    font-size: var(--font-text-m);
  }

  h1,
  h2 {
    text-align: center;
    font-weight: 500;
    font-family: var(--font-heading);
  }

  h1 {
    text-decoration: underline;
    font-weight: 800;
    line-height: 1.1111;
    margin: 0 0.8889em;
  }

  h2 {
    font-weight: 700;
    margin-block: 2em 1em;
    line-height: 1.33;
  }

  h1 + p {
    line-height: 1.75;
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }
`;
/* eslint-disable i18next/no-literal-string */
const Resume: NextPage = () => {
    const { t } = useTranslation('resume');
    return (<Content>
      <Doc>
        <SEO title={`${data.title} ${t('common:menu_resume')}`}/>

        <h1 className="mb-2">{data.title}</h1>
        <p className="my-5">{data.statement}</p>

        <section>
          <h2 className="mt-2 mb-1 text-xl capitalize">{t('skills')}</h2>
          {data.skills.map(({ heading, entries }) => (<p key={heading}>
              <span className="font-heading font-semibold">{heading}: </span>
              {entries.join(', ')}
            </p>))}
        </section>

        <section>
          <h2 className="mt-2 mb-1 capitalize">{t('job_history')}</h2>
          <ul>
            {data.history.map((job) => (<li key={job.employer.name + job.title} className="mt-6 mb-8">
                <div className="flex justify-between">
                  <h3>
                    {job.title} @ {job.employer.name} - {job.employer.location}
                  </h3>
                  <span>
                    {job.from} - {job.to}
                  </span>
                </div>
                <List className="pl-3">
                  {job.achievements.map((achievement) => (<li key={achievement}>{achievement}</li>))}
                </List>
                <span>Key Skills: {job?.keySkills?.join(', ')}</span>
              </li>))}
          </ul>
        </section>

        <section>
          <h2 className="mt-2 mb-1 text-xl capitalize">{t('education')}</h2>
          <ul>
            {data.education.map(({ school, subject, graduation, location }) => (<li key={school} className="my-2">
                <div className="flex justify-between">
                  <span>
                    {school} - {subject}
                  </span>
                  <span>
                    {location} - {graduation}
                  </span>
                </div>
              </li>))}
          </ul>
        </section>
      </Doc>
    </Content>);
};
const List = styled.ul `
  li {
    list-style-type: disc;
  }
`;
export default Resume;

    async function __Next_Translate__getStaticProps__1898874f5f2__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/resume',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1898874f5f2__ as getStaticProps }
  